<script setup lang="ts">
defineProps<{
  box: {
    lockCode?: string | null;
    currentDeliveryAssignment?: { apartmentName?: string };
  };
}>();
</script>

<template>
  <dl class="box-access" data-testid="provider-box-access">
    <div>
      <dt>Appartement de préparation</dt>
      <dd>{{ box.currentDeliveryAssignment?.apartmentName || 'Non affectée' }}</dd>
    </div>
    <div>
      <dt>Code cadenas</dt>
      <dd v-if="box.lockCode && /^\d{3}$/.test(box.lockCode)" class="box-access-code">
        {{ box.lockCode }}
      </dd>
      <dd v-else>Code indisponible</dd>
    </div>
  </dl>
</template>

<style scoped>
.box-access {
  display: grid;
  gap: 0.75rem;
  margin: 0.75rem 0;
  padding: 0.85rem;
  border: 1px solid #dce5df;
  border-radius: 12px;
  background: #f7f9fb;
  color: #162d40;
  min-width: 0;
  width: 100%;
  box-sizing: border-box;
}
.box-access dt {
  font-size: 0.85rem;
  font-weight: 600;
}
.box-access dd {
  margin: 0.2rem 0 0;
  font-weight: 700;
  overflow-wrap: anywhere;
}
.box-access .box-access-code {
  display: inline-block;
  padding: 0.3rem 0.7rem;
  border-radius: 8px;
  background: #0b2540;
  color: #fff;
  font-size: 1.8rem;
  line-height: 1.25;
  letter-spacing: 0.15em;
  font-variant-numeric: tabular-nums;
}
</style>
